export default __webpack_public_path__ + "static/media/enragingwound1.3a468d14.png";